module.exports = __webpack_public_path__ + "advancedSlideAlt.webp?d2a9dde9807be0341eab07d75033f0ab";